<template>
    <div class="page activity-list">

        <list-skeleton v-if="loading"></list-skeleton>

        <div v-else>

            <div class="activity-list-header">
                <div class="year" @click="yearPicker = true">{{year}} <img src="http://bytx.care-gobroad.com/static/bytx/activity_list_filter_icon.svg" /></div>

                <van-popup v-model="yearPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="years"
                        @confirm="onYearConfirm"
                        @cancel="positionPicker = false"
                    />
                </van-popup>

                <div class="tags">
                    <van-tabs type="card" :swipeable="true" v-model="month" @click="chooseMonth">
                        <van-tab v-for="(item,index) in months" :key="index" :title="item"></van-tab>
                    </van-tabs>
                    <div class="clear"></div>
                </div>
            </div>

            <div class="activity-list-container">
                <div v-if="finished && finished.length > 0" :class="'activity-list-section '+more">
                    <div class="activity-list-section-container" :key="val.time" v-for="(val,i) in finished">
                        <div class="activity-list-section-date">{{val.time}}</div>
                        <van-row class="activity-list-section-box" @click="go_detail(item)" :key="item.title" v-for="item in val.items">
                            <div class="activity-list-section-left">
                                <van-image
                                    fit="cover"
                                    class="activity-list-section-left-img"
                                    :src="item.cover_img"
                                    width="100%"
                                    height="100%"
                                />
                                <div class="activity-list-section-left-zl end" v-if="item.origin_type==4">
                                    <img src="/static/two/icon_list_tag_live_history.svg" alt="">
                                </div>
                            </div>
                            <div class="activity-list-section-right">
                                <div class="activity-list-section-right-title">{{item.title}}</div>
                                <div class="activity-list-section-right-time">{{item.date}}<span v-if="item.end_date && item.end_date!=''"> ~ {{item.end_date.substr(5,10)}}</span> </div>
                                <div v-if="item.status_text === '进行中'" class="activity-list-section-right-tags active">{{item.status_text}}</div>
                                <div v-else-if="item.status_text === '直播中'" class="activity-list-section-right-tags current">
                                    {{item.status_text}}
                                </div>
                                <div v-else-if="item.status_text === '未开始'" class="activity-list-section-right-tags end">
                                    {{item.status_text}}
                                </div>
                                <div v-else-if="item.status_text === '预告'" class="activity-list-section-right-tags appoint">
                                    {{item.status_text}}
                                </div>
                                <div v-else-if="item.status_text === '已预约'" class="activity-list-section-right-tags appoint">
                                    {{item.status_text}}
                                </div>
                            </div>
                            <div class="clear"></div>
                        </van-row>
                    </div>
                </div>

                <div v-if="!more && finished.length > 0" class="activity-list-pull-more" @click="showMore()">查看已结束的活动 <img src="http://bytx.care-gobroad.com/static/bytx/activity_list_pulldown_icon.svg" alt=""></div>
                <div v-else-if="more && finished.length > 0" class="activity-list-pull-more" @click="showMore()">收起已结束的活动 <img src="http://bytx.care-gobroad.com/static/bytx/activity_list_pullup_icon.svg" alt=""></div>

                <div v-if="un_finished && un_finished.length > 0" class="activity-list-section">
                    <div class="activity-list-section-container" :key="val.time" v-for="(val,i) in un_finished">
                        <div class="activity-list-section-date">{{val.time}}</div>
                        <van-row class="activity-list-section-box" @click="go_detail(item)" :key="item.title" v-for="item in val.items">
                            <div class="activity-list-section-left">
                                <van-image
                                    fit="cover"
                                    class="activity-list-section-left-img"
                                    :src="item.cover_img"
                                    width="100%"
                                    height="100%"
                                />
                                <div class="activity-list-section-left-zl appointment" v-if="item.origin_type==4 && item.type != 2">
                                    <img src="/static/two/icon_list_tag_live_count_down.svg" alt="">
                                </div>
                            </div>
                            <div class="activity-list-section-right">
                                <div class="activity-list-section-right-title">{{item.title}}</div>
                                <div class="activity-list-section-right-time">{{item.date}}<span v-if="item.end_date && item.end_date!=''"> ~ {{item.end_date.substr(5,10)}}</span></div>
                                <div v-if="item.status_text === '进行中'" class="activity-list-section-right-tags active">{{item.status_text}}</div>
                                <div v-else-if="item.status_text === '直播中'" class="activity-list-section-right-tags current">
                                    {{item.status_text}}
                                </div>
                                <div v-else-if="item.status_text === '已结束'" class="activity-list-section-right-tags end">
                                    {{item.status_text}}
                                </div>
                                <div v-else-if="item.status_text === '未开始'" class="activity-list-section-right-tags end">
                                    {{item.status_text}}
                                </div>
                                <div v-else-if="item.status_text === '预告'" class="activity-list-section-right-tags appoint">
                                    {{item.status_text}}
                                </div>
                                <div v-else-if="item.status_text === '已预约'" class="activity-list-section-right-tags appoint">
                                    {{item.status_text}}
                                </div>
                            </div>
                            <div class="clear"></div>
                        </van-row>
                    </div>
                </div>
                <van-empty v-if="finished.length == 0 && un_finished.length == 0" description="" image="/static/img/pic_blank_content.svg">
                    <template slot="description">
                        <div style="text-align: center">博医荟持续更新中…</div>
                        <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                        <div style="text-align: center;margin-top: 24px">
                            <van-button color="#0FB7AD" round size="small" style="width: 120px" :to="'/'">
                                返回首页
                            </van-button>
                        </div>
                    </template>
                </van-empty>
            </div>

        </div>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import listSkeleton from "@/skeleton/listSkeleton"

    export default {
        name: 'activity-list',
        components: {
            'list-skeleton': listSkeleton
        },
        data() {
            return {
                year : "2022",
                years: ["2020","2021","2022","2023"],
                month: "",
                months: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],

                value: "",
                active: "",
                recommend: [],
                list: [],
                loading: true,

                finished: [],
                un_finished: [],

                more:false,
                yearPicker:false,
            }
        },
        methods: {
            showMore(){
                this.more = !this.more
            },
            fetch(scene) {
                if (scene === 'list') {
                    let params = {
                        date: this.date,
                        pageSize: 999
                    }
                    Interface.getData('get', Interface.activity.list, params).then((res) => {
                        if(res.code === 0){
                            if (res.data.activity_finished) {
                                this.finished = res.data.activity_finished
                            }else{
                                this.finished = []
                            }
                            if (res.data.activity_un_finished) {
                                this.un_finished = res.data.activity_un_finished
                            }else{
                                this.un_finished = [];
                            }
                            if(this.un_finished.length == 0){
                                this.more = true
                            }else{
                                this.more = false
                            }
                        }
                        setTimeout(() => {
                            this.loading = false;
                        }, 500)
                    })
                }
            },
            go_detail(item) {
                if(item.origin_type === 2) {
                    //资讯
                    if(item.type == 1){
                        this.$router.push({'name':'article-detail',params:{id:item.content_id},query:{content_type:6}})
                    }else{
                        this.$router.push({'name':'article-column',params:{id:item.content_id},query:{content_type:6}})
                    }
                }else if (item.origin_type === 3){
                    //视频
                    if (item.type === 1){
                        this.$router.push({name:'video-detail',params: { id: item.content_id },query:{content_type:6}})
                    }else{
                        this.$router.push({'name':'video-column',params:{id:item.content_id},query:{content_type:6}})
                    }
                }else if (item.origin_type === 4){
                    //视频
                    if (item.type === 2) {
                        this.$router.push({'name': 'live-column', params: {id: item.content_id}})
                    } else if (item.live_status === 6) {
                        this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                    } else {
                        if (item.live_status === 0) {
                            this.$router.push({'name': 'live-detail', params: {id: item.content_id}})
                        } else {
                            this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                        }
                    }
                }else if (item.origin_type === 5){
                    Interface.goMeeting(this,{
                        uuid:item.uuid,
                        is_saas:item.is_saas,
                        type:item.type,
                    })
                }else if (item.origin_type === 11){
                  if(item.link != ""){
                    location.href = item.link
                  }else{
                    this.$router.push({'name': 'activity-detail',params:{id:item.id}})
                  }
                }
            },
            chooseMonth(){
                let month = this.month + 1
                this.date = this.year + "-" + ( month>=10 ? month : "0"+ month )
                this.fetch('list')
            },
            onYearConfirm(val,i){
                this.year = val
                this.chooseMonth()
                this.yearPicker = false
            }
        },
        created() {
            let time = new Date()
            this.month = time.getMonth()
            this.year  = time.getFullYear()
            this.chooseMonth()
            Interface.getShareInfo(this, "荟议日历", "", "医学会议百事通，关注的大会再也不错过", 44)
            sessionStorage.removeItem("search_data")
            let source_type = Interface.getUrl(window.location.href)
            if (source_type) {
                Interface.mFootPrint(0, 44,'', '', source_type, '荟议日历')
            } else {
                Interface.mFootPrint('',44,'','',0, '荟议日历')
            }
        },
    }
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/activity/list/index.vue